import { memo } from 'react';

import { Flex } from '@/lib/v2/components/Layout/Stack';
import { Text } from '@/lib/v2/components/Text';

import { Description } from '@/src/ContactsModule/components/ContactsViewInfo/ProgressCard';
import { loadingStatus } from '@/src/presentation/types/enum/importStatus.enum';

interface ProgressBarProps {
  percentage: number;
  status: loadingStatus;
  id?: string;
}

export const ProgressBar = memo(({ percentage, status, id }: ProgressBarProps) => {
  return (
    <div
      className="h-1.5 w-full rounded-full bg-gray-200 dark:bg-gray-700"
      data-testid="progressbar-component"
      id={id}
    >
      <div
        className={`
        ${
          status === loadingStatus.loading
            ? 'bg-blue-600 dark:bg-blue-500'
            : status === loadingStatus.error
            ? 'bg-[#FF4261]'
            : 'bg-[#18C678]'
        }
        h-1.5 rounded-full transition-all`}
        style={{ width: `${status === loadingStatus.error ? 100 : percentage}%` }}
      ></div>
    </div>
  );
});

interface DataCardProps {
  dataList: Description[];
  percentage: number;
  step: number;
  status: loadingStatus;
  id?: string;
}

export const DataCard = memo(({ dataList, percentage, step, status, id }: DataCardProps) => {
  const length = dataList.length - 1;

  return (
    <Flex column withGap data-testid={id || 'data-card-component'} gapSize="small" id={id}>
      <Flex withGap alignment="center" gapSize="medium">
        <div className="h-24 w-24">{step !== 0 && dataList[step - 1].icon}</div>
        <div className="h-32 w-32">{dataList[step].icon}</div>
        <div className="h-24 w-24">{step !== length && dataList[step + 1].icon}</div>
      </Flex>
      <ProgressBar percentage={percentage} status={status} />
      <Text alignment="center">{dataList[step].description}</Text>
    </Flex>
  );
});
